import React, { useState, useEffect } from "react";
import { Popover, Switch } from "antd";
import { Link } from "react-router-dom";
import TopbarUserWrapper from "./TopbarUser.style";
import { withTheme } from "styled-components";
import {
  LogoutOutlined,
  RightOutlined,
  UserOutlined,
  BgColorsOutlined,
} from "@ant-design/icons";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { setTheme } from "../../features/user/UserSlice";
import { useDispatch } from "react-redux";
// import { useThemeSwitcher } from "react-css-theme-switcher";
import { useUserRoleNames } from "../../hooks/accessControl";

const TopbarUser = (props) => {
  const dispatch = useDispatch();
  // const { switcher, currentTheme, status, themes } = useThemeSwitcher();
  const { theme, direction } = props;
  const [visible, setVisible] = useState(false);
  const user_name = useSelector((state) => state.user.profile.name);

  const themeName = useSelector((state) => state.user.theme);
  const handleVisibleChange = () => {
    setVisible(!visible);
  };
  const userRoleNames = useUserRoleNames();
  const roleName = userRoleNames[0];

  // const onThemeChange = (checked) => {
  //   switcher({ theme: checked ? themes.dark : themes.light });
  //   const newTheme = checked ? "dark" : "light";
  //   dispatch(setTheme(newTheme));
  // };

  const content = (
    <TopbarUserWrapper data-rtl={direction}>
      <div>
        <div className="itemContainer">
          <div className="itemLeft">
            <UserOutlined />
          </div>

          <div className="itemMiddle">
            <p className="primaryText">{user_name}</p>
          </div>
        </div>

        <div className="devider" />

        {/* <div className="itemContainer">
          <div className="itemLeft">
            <div className="iconContainer">
              <BgColorsOutlined />
            </div>
          </div>
          <div className="itemMiddle">
            <p className="primaryText">
              {<FormattedMessage id="app.topbar.dark_theme" />}
            </p>
          </div>

          <div className="itemRight">
            <Switch checked={themeName === "dark"} onChange={onThemeChange} />
          </div>
        </div>

        <div className="devider" /> */}

        <Link to={`/logout`}>
          <div className="itemContainer">
            <div className="itemLeft">
              <div className="iconContainer">
                <LogoutOutlined />
              </div>
            </div>
            <div className="itemMiddle">
              <p className="primaryText">
                {<FormattedMessage id="app.topbar.logout" />}
              </p>
            </div>

            <div className="itemRight">
              <RightOutlined />
            </div>
          </div>
        </Link>
      </div>
    </TopbarUserWrapper>
  );

  return (
    <TopbarUserWrapper>
      <Popover
        content={content}
        placement={"bottom"}
        trigger="click"
        open={visible}
        onOpenChange={handleVisibleChange}
        arrow={{ pointAtCenter: true }}
      >
        <div className="topbarUserContainer">
          <UserOutlined
            style={{
              padding: "5px",
              background: theme.palette["surfaceColor"][0],
              borderRadius: "20px",
              fontSize: "16px",
            }}
          />
          {roleName ? (
            <p className="topbarUserName">
              {user_name} ({roleName})
            </p>
          ) : (
            <p className="topbarUserName">{user_name}</p>
          )}

          <span className="userActivity online" />
        </div>
      </Popover>
    </TopbarUserWrapper>
  );
};

export default withTheme(TopbarUser);
